<template>
  <div id="final_score" 
      :style="{
          'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
      }">
    <div class="final_score_content">
    <!-- <div class="final_score_content" v-show="feedback.transition"> -->
      <p class="game_title"
      :style='{ 
        color : "#fff",
        background: colors.theme == "dark" ? colors[colors.theme].to : "#000"
      }'>Repense</p>
      <div class="completed">
        <span :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{completed}}</span>
				<span class="shadow" :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{completed}}</span>
      </div>
      <div class="final_score_value">
        <h1 :style='{color: colors.theme == "dark" ? "#fff" : "#000"}'>{{title}}</h1>
        <Coin class="coin" :fill='colors.theme == "dark" ? colors.primary : "#000"'></Coin>
        <span class="score_value" :style='{color: colors.theme == "dark" ? colors.primary : "#000"}'>{{(score).toLocaleString("pt-br")}}</span>
      </div>
      <div
        @click="nextRoute"
        :title="$t('views.finalScore.option_button')"
        class="option-button"
        :style="{
        background: colors && colors.secondary,
        borderBottom: colors && `7px solid ${colors[colors.theme].from}`
      }"
      >
        <span>{{buttonNext.textButton}}</span>
      </div>
    </div>
    <span class="gupy-warning" v-if="gupyService">Para que seu resultado seja enviado você deve avançar até a última tela do relatório</span>
    <!-- <visual-feedback
      :showFeedback="feedback.showFeedback"
      :transition="feedback.transition"
      :attempt="feedback.attempt"
      :colorTheme="colors.theme"
      :fiveMinutes="feedback.fiveMiutes"
    ></visual-feedback> -->
  </div>
</template>

<script>
// import visualFeedback from "./../components/shared/default/FeedbackAttempt";
import Coin from "./../components/shared/customIcons/ExtractCoin"
export default {
  components: {
    // "visual-feedback": visualFeedback
    Coin
  },
  data: function() {
    return {
      buttonNext: {
        textButton: this.$t("views.finalScore.visualFeedback.buttonNext"),
      },
      workspaceId: localStorage.getItem("workspaceId"),
      gupyService: {},
      score: this.$store.getters.getGameData("currentScore"),
      title: this.$t("views.finalScore.visualFeedback.title"),
      completed: this.$t("views.finalScore.visualFeedback.completed"),
      feedback: {
        showFeedback: true,
        fiveMiutes: false,
        transition: false,
        attempt: ""
      },
      colors: {},
      hasReloaded: '',
      reload: true
    };
  },
  created() {
    if(this.score == null || undefined){
      localStorage.setItem('reload', this.reload);
      location.reload(true);
    }
    this.colors = JSON.parse(localStorage.getItem("colors"));
    this.feedback.attempt = "game_over_loop";
    this.gupyService = localStorage.getItem("gupyService")

    // setTimeout(() => {
    //   this.feedback.transition = true;
    //   setTimeout(() => {
    //     this.feedback.showFeedback = false;
    //   }, 1000);
    // }, 3200);
  },
  methods: {
    nextRoute() {
      this.$router.push({ path: "/report/statement" });
    }
  }
};
</script>

<style lang="scss" scoped>
#final_score {
  background-size: cover !important;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;

  .final_score_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .game_title{
      text-transform: uppercase;
      font-weight: 600;
      letter-spacing: 4px;
      font-size: 17px;
      border-radius: 300px;
      padding: 5px 32px;    
    }
    .completed{
			display: flex;
			flex-direction: column;
			margin-top: 15px;


			.shadow{
				-webkit-text-fill-color: transparent;
				-webkit-text-stroke-width: 1px;
				// -webkit-text-stroke-color: white;
				position: relative;
				top: -53px;
				left: 3px;
			}
			span{
				font-size: 55px;
				font-weight: 900;
				text-transform: uppercase;
				letter-spacing: 0px;			
				// text-shadow: 2px 2px 0px rgba(250, 250, 250, 1);			
			}
		}
    .final_score_value{
      display: flex;
      width: 100%;
      justify-content: center;      
      margin-bottom: 32px;
      margin-top: -32px;
      font-size: 23px;
      font-weight: 700;
      align-items: center;

      .coin{
        width: 40px;
        height: 40px;
        padding: 0 12px;
      }
    }
  }

  // h1 {
  //   letter-spacing: 2px;
  //   word-spacing: 2px;
  //   text-transform: uppercase;
  //   font-weight: 600;
  // }

  .option-button {
    width: 50%;
    border: none;
    padding: 15px 50px;
    letter-spacing: 3px;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 13px;
    color: #fff;
    border-top:none;
    outline: none;
    text-align: center;
    transition: border-bottom 0.8s;
    border-radius: 50px;

    &:active {
      box-shadow: none;
      border-bottom: none;
    }
  }
  .gupy-warning{
    padding: 32px 0;
    font-weight: bold;    
    text-align: center;
  }
}
</style>
